<div class="card list mb-0">
  <div class="card-body">
    <div class="row">
      <div class="col-xl-4 col-lg-4 mb-3 mb-lg-0">
        <img
          class="hubriseimg pr-2"
          src="/assets/img/HubRise.png"
          width="100%"
          style="max-width: 180px"
        />
        <app-help-icon [helpPageName]="helpUrl"></app-help-icon>
      </div>
      <div class="col-xl-8 col-lg-8">
        <div class="row" *ngIf="isDashboard && !isConnected">
          <app-explanation
            class="italic col-lg-12 mb-2"
            text="admin.store.setting.integrations.shareDataWithOtherApplications"
          ></app-explanation>
          <div class="col-lg-12">
            <div class="d-flex align-items-center justify-content-between p-0">
              <app-connect-button
                [showLayout]="false"
                [classes]="'mt-2'"
                (clickEvent)="connectToHubrise()"
              >
              </app-connect-button>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="!isDashboard && isConnected">
          <div class="col-lg-12">
            <div class="col-lg-12 p-0 pl-sm-3 pl-3">
              <form [formGroup]="hubriseSettingsForm">
                <div class="row d-flex align-items-center">
                  <div class="form-group col-12 p-0">
                    <span class="italic mr-4 mb-3">
                      {{
                        'admin.store.setting.integrations.connectedToHubrise'
                          | translate
                      }}
                    </span>
                  </div>
                  <div class="form-row col-12 p-0 mb-4">
                    <span class="col-sm-3"
                      >{{ 'admin.store.location.location' | translate }}:</span
                    >
                    <span class="col-sm-9">{{
                      hubriseSettingsForm.get('HUBRISE_LOCATION_NAME').value
                    }}</span>
                  </div>
                  <div class="form-row col-12 p-0 mb-4">
                    <span class="col-sm-3"
                      >{{
                        'admin.store.settings.catalog.title' | translate
                      }}:</span
                    >
                    <span class="col-sm-9">{{
                      hubriseSettingsForm.get('HUBRISE_CATALOG_NAME').value
                    }}</span>
                  </div>
                  <div class="form-row col-12 p-0 mb-4">
                    <span class="col-sm-3"
                      >{{
                        'admin.store.setting.integrations.hubriseCustomerList'
                          | translate
                      }}:</span
                    >
                    <span class="col-sm-9">{{
                      hubriseSettingsForm.get('HUBRISE_CUSTOMER_LIST_NAME')
                        .value
                    }}</span>
                  </div>
                  <div class="form-group row col-md-12 mb-4">
                    <div class="mr-5">
                      <a
                        class="btn btn-primary active"
                        href="https://manager.hubrise.com/"
                        target="_blank"
                      >
                        {{
                          'admin.store.setting.integrations.goToHubrise'
                            | translate
                        }}
                      </a>
                    </div>
                  </div>
                  <div
                    class="form-group row col-md-12 mb-4"
                    *ngIf="
                      hubriseSettingsForm.get('HUBRISE_ACCESS_TOKEN').value
                    "
                  >
                    <div class="mr-5">
                      <app-button
                        [variant]="'primary'"
                        [classes]="'px-2 mb-2 pos-integration-btn'"
                        (click)="syncCatalog()"
                      >
                        {{
                          'admin.store.setting.integrations.powersoft.synchronizeCatalog'
                            | translate
                        }}
                      </app-button>
                    </div>
                  </div>
                  <div class="col-md-12 d-flex justify-content-end">
                    <app-disconnect-button
                      [showLayout]="false"
                      (clickEvent)="disconnectFromHubrise()"
                    >
                    </app-disconnect-button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
